// Styles
import './image-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initImageSliderBanner = (context) => {
  const imageSliderSection = context.closest('.shopify-section');
  if (!imageSliderSection) return;

  const slidesContainer = imageSliderSection.querySelector(
    '.section-image-slider__container__right__slider',
  );
  const slides = slidesContainer.querySelectorAll(
    '.swiper-wrapper .swiper-slide',
  );
  const slidesCount = slides.length;

  if (slidesCount > 1) {
    const swiper = new Swiper(
      imageSliderSection.querySelector(
        '.section-image-slider__container__right__slider',
      ),
      {
        loop: false,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: true,
        breakpoints: {
          1025: {
            slidesPerView: 2.2,
              spaceBetween: 16,
              centeredSlides: false,
            },
            1200: {
                slidesPerView: (function () {
                  const slides = imageSliderSection.querySelectorAll('.swiper-slide');
                  return slides && slides.length <= 3 ? 3 : 3.2;
                })(),
            spaceBetween: 16,
            centeredSlides: false,
          },
        },
      },
    );
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.section-image-slider'), (el) => {
    window.dAgency.initImageSliderBanner(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.section-image-slider'),
      (el) => {
        window.dAgency.initImageSliderBanner(el);
      },
    );
  });
}
